import ttt from './initializedTtt';

const trackAction = (action, contextData = {}) => {
  ttt.event('PropTrackAction', { PropTrackAction: action, ...contextData });
};

export default trackAction;
